import {axios} from '@/api/axios';
import {AxiosResponse} from 'axios';
import {CHANNEL_URLS} from '@/api/urls';
import {formatString} from '@/utils';
import {Channel} from '@/types/channel';

export const ChannelApi = {
  getList: () => axios.get<Channel[]>(CHANNEL_URLS.GET_LIST),
  getOne: (channelId: string) => axios.get<Channel>(formatString(CHANNEL_URLS.GET_ONE, channelId)),

  save: (data: any) => axios.post<Required<Channel>>(CHANNEL_URLS.SAVE, data),
  edit: (channelId: string, data: Channel) => axios.put<AxiosResponse<Channel>>(formatString(CHANNEL_URLS.EDIT, channelId), data)
};
